import {SvgIconProps, SvgIcon} from '@mui/material';
import React from 'react';

export const ZoomIcon = ({...props}: SvgIconProps & {}) => {
  const StrokeColor = props.color === 'primary' ? '#31CDD3' : '#181C32';
  return (
    <SvgIcon
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="none"
      stroke={StrokeColor}
      strokeLinecap="round"
      strokeLinejoin="round"
      width="32"
      height="32"
      strokeWidth="1.25"
      sx={{fill: 'none', ...props.sx}}
      {...props}>
      <path d="M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0"></path>
      <path d="M7 10l6 0"></path>
      <path d="M10 7l0 6"></path>
      <path d="M21 21l-6 -6"></path>
    </SvgIcon>
  );
};
